import TemplateTasksSection from 'components/SlideOver/dataSlideOver/data/slideOverAddMission/missionTemplate/templateTasksSection';
import { missionDetailText } from './missionDetailTexts';

const toTaskLabels = (values) =>
  (Array.isArray(values) ? values : []).filter(
    (label) => typeof label === 'string' && label.trim() !== '',
  );

/**
 * Tasks the api resolves for the mission (`missionTasks`: its own, otherwise
 * its qualification's), falling back on the tasks stored on the mission.
 */
export const missionTaskLabels = (infoMission) => {
  const resolved = toTaskLabels(infoMission?.missionTasks);
  return resolved.length > 0 ? resolved : toTaskLabels(infoMission?.tasks);
};

/**
 * « Tâches » sub-tab of the mission detail. Editing, the tasks section of the
 * job description wizard runs on `taskForm` (see missionTaskForm.js); until
 * that form is built, the list stays read only.
 */
const MissionTasksTab = ({
  infoMission,
  isEditing,
  taskForm,
  onTaskFormChange,
}) => {
  if (isEditing && taskForm) {
    return (
      <div data-testid="mission-detail-tasks">
        <TemplateTasksSection
          form={taskForm}
          setForm={onTaskFormChange}
          addedLabel={missionDetailText('tasks.added')}
        />
      </div>
    );
  }

  const tasks = missionTaskLabels(infoMission);

  return (
    <div className="flex flex-col gap-3" data-testid="mission-detail-tasks">
      {tasks.length > 0 ? (
        <ul className="list-disc pl-5 flex flex-col gap-2 text-gray-700">
          {tasks.map((task, index) => (
            <li key={`${index}-${task}`}>{task}</li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500">{missionDetailText('tasks.empty')}</p>
      )}
    </div>
  );
};

export default MissionTasksTab;
